import { render, staticRenderFns } from "./mateSticFor.vue?vue&type=template&id=e4c659ce&scoped=true&"
import script from "./mateSticFor.vue?vue&type=script&lang=js&"
export * from "./mateSticFor.vue?vue&type=script&lang=js&"
import style0 from "./mateSticFor.vue?vue&type=style&index=0&id=e4c659ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c659ce",
  null
  
)

export default component.exports